import React from 'react';
import PropTypes from 'prop-types';
import {Modal, Image} from '@learningblocks/exp-components';
import {ErrorLimitExceeded} from '@learningblocks/exp-components/lib/ErrorLimitExceeded';
import IncorrectCounter from '@learningblocks/exp-constants/lib/Images/incorrect-counter.svg';
import './style.scss';

export class ErrorCountBar extends React.Component {
  renderErrorLimitExceededModal = () => {
    const {incorrects, maxIncorrects} = this.props;
    if (incorrects >= maxIncorrects) {
      return (
        <Modal
          isOpen={incorrects >= maxIncorrects}
          contentLabel='Error Limit Exceeded'
          className='Modal sm'
          size='sm'>
          <ErrorLimitExceeded />
        </Modal>
      );
    } else {
      return null;
    }
  };
  render() {
    const {incorrects, maxIncorrects} = this.props;
    return (
      <>
        <div className='error-steps'>
          {this.props.children}
          <span>
            <Image src={IncorrectCounter} alt='incorrect_counter' />
            <p>
              {incorrects}/{maxIncorrects}
            </p>
          </span>
        </div>
        {this.renderErrorLimitExceededModal()}
      </>
    );
  }
}
ErrorCountBar.propTypes = {
  incorrects: PropTypes.number,
  maxIncorrects: PropTypes.number,
  children: PropTypes.element,
};
